import {default as MUIGrid} from '@mui/material/Unstable_Grid2';
import {styled} from '@mui/material/styles';

const Grid = styled(MUIGrid)(({}) => ({}));

export default Grid;
